/* tslint:disable */

export const faRectanglePortrait: any = {"prefix":"fas","iconName":"rectangle-portrait","icon":[384,512,[],"f2fb","M0 464V48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"]};